import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import PageDialogOverlay from 'components/PageDialogOverlay';
import SupportButton from 'components/SupportButton';
import { isAuthenticated } from 'utils/auth';
import { SUPPORT_SOCIAL_PHONE_TEL } from 'utils/constants';
import { getUserData } from 'utils/graphQLFunctions';
import { errorShape, userShape } from 'utils/shapes';
import {
  clearCallbacks,
  hideChat,
  setCallbacks,
  setUserData,
  showChat
} from 'utils/zendesk';
import IconArrowRight from 'resources/arrow-right-icon.svg';
import './SupportPage.css';

const supportRightPanelData = [
  {
    title: `What's New`,
    link: '/whats-new',
    alt: 'go to Whats New'
  },
  {
    title: 'FAQs',
    link: '/faq',
    alt: 'go to FAQs'
  },
  {
    title: 'Terms of Service',
    link: '/terms',
    alt: 'go to Terms of Service'
  },
  {
    title: 'Privacy Policy',
    link: '/privacy',
    alt: 'go to Privacy Policy'
  },
  {
    title: 'Responsible Gaming',
    link: '/responsible-gaming',
    alt: 'go to Responsible Gaming'
  }
];

class SupportPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      openReportGamePage: false,
      isChatOpen: false
    };
  }
  componentDidMount() {
    const user = this.props.data && this.props.data.user;
    if (user) {
      setUserData(user);
    }
    setCallbacks({
      onHide: this.chatWidgetClose,
      onShow: this.chatWidgetOpen,
      onChatStart: this.chatWidgetOpen,
      onChatEnd: this.chatWidgetClose
    });
  }

  componentDidUpdate(prevProps) {
    const prevUser = prevProps.data && prevProps.data.user;
    const nextUser = this.props.data && this.props.data.user;
    if (prevUser !== nextUser) {
      setUserData(nextUser);
    }
  }

  componentWillUnmount() {
    clearCallbacks({
      onHide: this.chatWidgetClose,
      onShow: this.chatWidgetOpen,
      onChatStart: this.chatWidgetOpen,
      onChatEnd: this.chatWidgetClose
    });
  }

  chatWidgetClose = () => {
    this.setState({
      isChatOpen: false
    });
  };

  chatWidgetOpen = () => {
    this.setState({
      isChatOpen: true
    });
  };

  reportPageClosed = () => {
    this.setState({
      openReportGamePage: false
    });
  };

  render() {
    return (
      <PageDialogOverlay
        parentClassName="support"
        headerTitle="Support"
        pageTitle="Support"
        closeEnable={true}
        scrolling
      >
        <div className="support-container">
          <div className="support-left-panel">
            <h2 className="support-left-panel-title">Have a Question?</h2>
            <div className="support-widgets">
              <div>
                <h5 className="chat-online-text">Chat online</h5>
                <button
                  className="support-chat-button"
                  type="submit"
                  onClick={showChat}
                >
                  Chat
                </button>
                <h6 className="chat-online-zendesk-text">powered by Zendesk</h6>
              </div>
              <div className="support-call-us-desktop">
                <h5 className="chat-online-text">Or Call Us </h5>
                <a
                  className="support-call-us-number"
                  href={SUPPORT_SOCIAL_PHONE_TEL}
                >
                  (866) 946-3387
                </a>
                <h5 className="support-line-text">Our US support line</h5>
              </div>
              <div className="support-call-us-mobile">
                <h5 className="chat-online-text">Or Call Us </h5>
                <button
                  className="support-chat-button"
                  type="submit"
                  onClick={() => {
                    window.location.href = SUPPORT_SOCIAL_PHONE_TEL;
                  }}
                >
                  Call
                </button>
                <h6 className="chat-online-zendesk-text">
                  Call our US support line at{' '}
                  <p className="support-phone-num">(866) 946-3387</p>
                </h6>
              </div>
            </div>
            {isAuthenticated() && (
              <div className="support-widgets">
                <div>
                  <h5 className="report-issue-text">
                    Need to report a game issue?
                  </h5>
                  <button
                    className="report-issue-button"
                    type="submit"
                    onClick={() => {
                      hideChat();
                      this.setState({
                        openReportGamePage: true
                      });
                    }}
                  >
                    Report
                  </button>
                </div>
              </div>
            )}
          </div>
          <div className="support-right-panel">
            <div className="quick-link-widgets">
              {supportRightPanelData.map((item, index) => (
                <div
                  className="quick-support-link"
                  key={`${item.link}+${index}`}
                >
                  <Link
                    className="quick-support-text text-button"
                    to={item.link}
                  >
                    {item.title}
                  </Link>
                  <Link className="support-quick-link-button" to={item.link}>
                    <img src={IconArrowRight} alt={item.alt} />
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
        {this.state.isChatOpen && <div class="support-page-overlay"></div>}
        {this.state.openReportGamePage && (
          <SupportButton
            withReportGameIssue={this.state.openReportGamePage}
            fromSupportPage={this.state.openReportGamePage}
            closeCallBack={this.reportPageClosed}
          />
        )}
      </PageDialogOverlay>
    );
  }
}

SupportPage.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool,
    error: errorShape,
    user: userShape
  })
};

const withUserData = getUserData({ skip: () => !isAuthenticated() });

export default withUserData(SupportPage);
